import {
	applySsidTemplateFilter,
	focusSsidTemplate,
	openSsidTemplateSection,
} from './adapter';
import {
	openSsidTemplateEditModal,
	openSsidTemplateCreateModal,
	openSsidTemplateDeleteModal,
} from './modal';
import {mapSsidPrefill} from '../ssid/prefill';
import {resolveSsidTemplates} from './resolver';

/**
 * Open and optionally filter the Template inventory.
 * @param {object} command experience command
 * @return {Promise<void>} completion
 */
async function openInventory(command) {
	await openSsidTemplateSection();
	const query = command.params?.query;
	if (typeof query === 'string' && query.trim()) {
		await applySsidTemplateFilter(query);
	}
}

const ssidTemplatePlugin = {
	id: 'ssid_template',
	version: 1,
	commandVersion: 1,
	resource: 'ssid_template',
	operations: ['options', 'view', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		resolvers: ['aaa_server', 'multi_psk'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.ssid_templates': openSsidTemplateSection,
	},
	resolvers: {
		template: resolveSsidTemplates,
	},
	filters: {
		template: (command) => applySsidTemplateFilter(command.params?.query),
	},
	focusHandlers: {
		template: (command) => focusSsidTemplate(command.params?.entity_id),
	},
	modals: {
		'ssid_template.create': openSsidTemplateCreateModal,
		'ssid_template.edit': openSsidTemplateEditModal,
		'ssid_template.delete': openSsidTemplateDeleteModal,
	},
	prefillMappers: {
		'ssid_template.create': mapSsidPrefill,
		'ssid_template.edit': mapSsidPrefill,
	},
	experiences: {
		'ssid_template.inventory': openInventory,
	},
};

export default ssidTemplatePlugin;
